import graphql__5419095f489bc6e3ade6 from "./__generated__/BookmarkedFilter_participativeModule.graphql.js";import { graphql, useFragment } from "react-relay";
import { defineMessages } from "react-intl";
import { useDispatch } from "react-redux";
import classNames from "classnames";

import Button from "../Buttons/Button";
import { useFormatMessage } from "../Intl/Context";
import { updateBookmarkedOnly } from "../../reducers/resourcesList/search";
import { useResourcesList } from "../ResourcesList/resourcesList";
import { isUnauthorized } from "../Utils/authorizations";

const BookmarkedFilter = props => {
  const participativeModule = useFragment(
    BookmarkedFilter_participativeModule,
    props.participativeModule
  );
  const { bookmarksCreationAuthorized } = participativeModule.authorizations;

  const t = useFormatMessage();
  const bookmarksLabel = t(intlMessages.bookmarks);
  const bookmarkedFilterSrLabel = t(intlMessages.bookmarkedFilterSrLabel);

  const { resourcesListKey, search } = useResourcesList();
  const { bookmarkedOnly } = search;

  const dispatch = useDispatch();
  const handleButtonClicked = () =>
    dispatch(updateBookmarkedOnly(resourcesListKey, !bookmarkedOnly));

  if (isUnauthorized(bookmarksCreationAuthorized)) return null;

  const className = classNames(["filter", "bookmarks-filter", props.className]);
  const iconClassName = classNames([
    "icon-featured",
    "margin-right-xs",
    "text-shadow-primary",
    {
      "text-white": !bookmarkedOnly,
      "text-primary": bookmarkedOnly
    }
  ]);

  return (
    <div className={className}>
      <Button
        aria-label={bookmarkedFilterSrLabel}
        type="button"
        className="btn-unstyled btn-block one-line"
        onClick={handleButtonClicked}
        label={bookmarksLabel}
        iconClassName={iconClassName}
        innerClassName="d-inline-flex align-items-center"
      />
    </div>
  );
};

const BookmarkedFilter_participativeModule = graphql__5419095f489bc6e3ade6;

export default BookmarkedFilter;

const intlMessages = defineMessages({
  bookmarks: {
    id: "proposals.list.filters.bookmarks",
    defaultMessage: "Mes favoris"
  },
  bookmarkedFilterSrLabel: {
    id: "proposals.list.filters.bookmarkedFilterSrLabel",
    defaultMessage: "Filtrer par mes favoris"
  }
});
